export const FETCH__LIST__TYPE__JOBS__SUCCESS ="FETCH__LIST__TYPE_JOBS__SUCCESS"
export const FETCH__LIST__TYPE__JOBS__FAIL = "FETCH__LIST__TYPE__JOBS__FAIL"

export const FETCH__ADD__JOB__TYPE__SUCCESS = "FETCH__ADD__JOB__TYPE__SUCCESS"
export const FETCH__ADD__JOB__TYPE__FAIL = "FETCH__ADD__JOB__TYPE__FAIL"

export const FETCH__DETAIL__TYPE__JOB__SUCCESS = "FETCH__DETAIL__TYPE__JOB__SUCCESS"
export const FETCH__DETAIL__TYPE__JOB__FAIL = "FETCH__DETAIL__TYPE__JOB__FAIL"